import find from "lodash-es/find";

import markerIcons from "./markerIcons.js";
import webColors from "./webColors.js";

// returns the correct market icon for a pin
export const colorToMarkerIcon = (point, activeMarkerId) => {
  const { marker } = point;
  const icon = find(markerIcons, { name: point.marker });
  let color;

  // marker must be defined
  if (!marker) {
    return undefined;
  }

  // ======== Determine the pin's icon image (by marker type, size, and color) ========= //

  // this is the clicked pin
  if (activeMarkerId === point.id) {
    color = find(webColors, { name: "Lime" });
  } else {
    color = find(webColors, { name: point.color });
    if (!color) {
      color = find(webColors, { name: "Black" });
    }
  }

  return { color: color, icon: icon };
};
